import React from "react";

export default React.createContext({
    lazyParams: {},
    setLazyParams: () => { },
    rechercheApi: () => { },
    totalOffresRecords: 0,
    tokenResetFilters : null
});